import React, { createContext, useContext, useEffect, useState } from "react";
import {
  login as loginApi,
  register as registerApi,
  verifyOtp as verifyOtpApi,
} from "../api/auth";

const AuthContext = createContext(null);
const AUTH_STORAGE_KEY = "civix-auth";

const storedAuth = () => {
  try {
    return JSON.parse(localStorage.getItem(AUTH_STORAGE_KEY));
  } catch {
    return null;
  }
};

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(storedAuth());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  const login = async ({ email, password }) => {
    const result = await loginApi({ email, password });
    if (result.requiresOtp) {
      return result;
    }

    const authState = { user: result.user, token: result.token };
    setAuth(authState);
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authState));
    return authState;
  };

  const verifyOtp = async ({ email, otp }) => {
    const result = await verifyOtpApi({ email, otp });
    const authState = { user: result.user, token: result.token };
    setAuth(authState);
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authState));
    return authState;
  };

  const register = async ({ firstName, lastName, email, password }) => {
    const result = await registerApi({ firstName, lastName, email, password });
    setAuth(null);
    localStorage.removeItem(AUTH_STORAGE_KEY);
    return result;
  };

  const logout = () => {
    setAuth(null);
    localStorage.removeItem(AUTH_STORAGE_KEY);
  };

  return (
    <AuthContext.Provider
      value={{
        user: auth?.user || null,
        token: auth?.token || null,
        loading,
        login,
        verifyOtp,
        register,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};

export { AuthProvider, useAuth };
